import * as classnames from 'classnames';
import * as React from 'react';
import styled from 'styled-components';
import { SpinnerIcon } from '@estee/elc-icons';
import { spinnerContainerTheme } from '../theme/default-theme';

export interface ISpinner {
    className?: string;
    children?: React.ReactNode;
    isLoading?: boolean;
}
export interface ISpinnerState {
    isLoading: boolean;
}

const SpinnerContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    ${spinnerContainerTheme};
`;

const Container = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;

export class SpinnerComponent extends React.Component<ISpinner, ISpinnerState> {
    constructor(props: ISpinner) {
        super(props);
    }
    public render() {
        const spinnerClassName = classnames('elc-spinner', 'js-spinner', this.props.className);
        const spinnerContainerClassName = classnames(
            'elc-spinner-container',
            'js-spinner-container',
            this.props.className
        );
        const spinnerIconContainerClassName = classnames(
            'elc-spinner-icon-container',
            'js-spinner-icon-container'
        );

        return (
            <Container className={spinnerContainerClassName}>
                {this.props.isLoading && (
                    <SpinnerContainer className={spinnerIconContainerClassName}>
                        <SpinnerIcon className={spinnerClassName} />
                    </SpinnerContainer>
                )}
                {this.props.children}
            </Container>
        );
    }
}
